import React from 'react'
import ClipboardContainer from '../../../../Components/Forms/FormWidgets/Clipboard'

export default function Clipboard() {
  return (
    <div className='page-body'>
        <ClipboardContainer/>
    </div>
  )
}
